// keyMapper.ts
// ———————————————————————————————————————————————————————————————
// Mapeo de claves unificadas a elementos CMI específicos de cada versión
// ———————————————————————————————————————————————————————————————

import type { Key, Version } from './types';

const map12: Record<Key, string | null> = {
  learnerId: "cmi.core.student_id",
  learnerName: "cmi.core.student_name",
  bookmark: "cmi.core.lesson_location",
  suspendData: "cmi.suspend_data",
  completion: "cmi.core.lesson_status",
  success: "cmi.core.lesson_status",
  lessonMode: "cmi.core.lesson_mode",
  credit: "cmi.core.credit",
  entry: "cmi.core.entry",
  exit: "cmi.core.exit",
  scoreRaw: "cmi.core.score.raw",
  scoreMin: "cmi.core.score.min",
  scoreMax: "cmi.core.score.max",
  scoreScaled: null,
  progressMeasure: null,
  totalTime: "cmi.core.total_time",
  sessionTime: "cmi.core.session_time",
  launchData: "cmi.launch_data",
};

const map2004: Record<Key, string | null> = {
  learnerId: "cmi.learner_id",
  learnerName: "cmi.learner_name",
  bookmark: "cmi.location",
  suspendData: "cmi.suspend_data",
  completion: "cmi.completion_status",
  success: "cmi.success_status",
  lessonMode: "cmi.mode",
  credit: "cmi.credit",
  entry: "cmi.entry",
  exit: "cmi.exit",
  scoreRaw: "cmi.score.raw",
  scoreMin: "cmi.score.min",
  scoreMax: "cmi.score.max",
  scoreScaled: "cmi.score.scaled",
  progressMeasure: "cmi.progress_measure",
  totalTime: "cmi.total_time",
  sessionTime: "cmi.session_time",
  launchData: "cmi.launch_data",
};

/**
 * Obtiene el elemento CMI correspondiente a una clave unificada
 * según la versión de SCORM
 */
export function getCMIElement(key: Key, version: Version | null): string | null {
  if (!version) return null;
  return version === "2004" ? map2004[key] : map12[key];
}

/**
 * Verifica si la versión actual es SCORM 2004
 */
export function is2004(version: Version | null): boolean {
  return version === "2004";
}
